import { SupermarketFormat } from '../CoffeeCardWeb/types';

// Frontend mirror of the backend services/coffee/supermarketCatalog.ts →
// supermarketRateCategories. Keep IDENTICAL: the backend recomputes the overall
// from these same weights, so the client only renders the criteria — it never
// decides the score. Deriving the criteria from the selected type's `format`
// (instead of trusting the backend `categories` field) lets a brand-new CUSTOM
// type — which has no persisted catalog entry yet — show the right sliders.
//
// Always present: `taste` (core, required) + `value` (worth-the-price).
// Conditionally: `creaminess` when there's milk, `sweetness` when there's sugar.
export function supermarketRateCategories(
    format: SupermarketFormat,
): Record<string, { weight: number; required: boolean }> {
    const categories: Record<string, { weight: number; required: boolean }> = {
        taste: { weight: 3, required: true },
    };
    if (format.milk) categories.creaminess = { weight: 2, required: false };
    if (format.sugar) categories.sweetness = { weight: 1, required: false };
    categories.value = { weight: 2, required: false };
    return categories;
}

// A `coffeeFormat` shape for CoffeeRatingSection's category filter. The filter drops
// sugar/milk-token categories unless `sugar`/`milk` are non-undefined, so set each key
// only when the type's format actually has it. This keeps creaminess/sweetness visible
// for a custom type (whose backend `categories` we deliberately don't rely on).
export function supermarketCoffeeFormat(
    format: SupermarketFormat,
): { sugar?: boolean; milk?: boolean } {
    const coffeeFormat: { sugar?: boolean; milk?: boolean } = {};
    if (format.sugar) coffeeFormat.sugar = true;
    if (format.milk) coffeeFormat.milk = true;
    return coffeeFormat;
}
